<!--<div medptevlog>-->

<div class="modal-header">
  <h2 class="modal-title">Delegate Training</h2>
  <span type="button" medpt-log-action="Click" medpt-log-message="Close Delegate Training Modal" (click)="modal.close(false)" class="btn-close" id="spDelegateClose"></span>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-12 columns">
      <div *ngIf="DelegateTrainingInputData.Assets.length == 0;then noSelection else showSelectedTraining"></div>
      <ng-template #noSelection>Please select at least one training to delegate the training.</ng-template>
      <ng-template #showSelectedTraining>
        <form class="form-horizontal" [formGroup]="delegateform" (ngSubmit)="SubmitDelegatedInfo()" id="delegateform">
          <div class="col col-md-12">
            <label><strong>Delegate From: {{DelegateTrainingInputData.DelegateUser.Name}}</strong></label>
          </div>
          <div class="col col-md-12" formArrayName="DelegateTrainingList">
            <kendo-grid [data]="DelegateTrainingInputData.Assets" class="nofloating">
              <kendo-grid-column field="AssetName" title="Training">
                <ng-template kendoGridCellTemplate let-dataItem let-formGroup="delegateform">
                  <div style="display:flex">
                    {{dataItem.AssetName}}
                    <div class="ms-2" matTooltip="Periodic training"
                         [matTooltipPosition]="'above'">
                      <img alt="Periodic Training" width="16" height="16" src="{{cdnEndPoint}}/triport/icons/Replay-grey.svg" *ngIf="dataItem.IsReoccurring" />
                    </div>
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column field="DelegatedUserId" title="Delegate To" [width]="300">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <div [formGroupName]="rowIndex">
                    <kendo-dropdownlist [data]="userFilteredData"
                                        textField="DisplayName"
                                        valueField="UserID"
                                        [valuePrimitive]="true"
                                        [defaultItem]="defaultItem"
                                        min=1,
                                        [filterable]="true"
                                        (filterChange)="filterData($event)"
                                        formControlName="DelegatedUserId"
                                        [ngClass]="{'input-validation-error': delegateform.value.DelegateTrainingList[rowIndex].invalid && delegateform.value.DelegateTrainingList[rowIndex].touched}">
                      <ng-template kendoDropDownListItemTemplate let-dataItem>
                        <span>{{dataItem.DisplayName}} <span *ngIf="dataItem.UserID != ''">({{dataItem.RoleName}})</span></span>
                      </ng-template>
                      <ng-template kendoDropDownListNoDataTemplate>
                        No User(s) Found
                      </ng-template>
                    </kendo-dropdownlist>
                  </div>
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </div>
          <div class="col col-md-12">
            <label class="col-form-label">Comments <span class="text-danger">*</span><small>(Max 2500 chars.)</small><span class="d-block is-invalid-message small" *ngIf="(delegateform.controls['Reason'].touched || DelegateFormSubmitted) && delegateform.controls['Reason'].errors?.['required']">Comments are required</span></label>
            <br />
            <textarea placeholder="Enter Comment" formControlName="Reason" class="" maxlength="2500" [ngClass]="{'is-invalid': delegateform.controls['Reason'].invalid && (delegateform.controls['Reason'].touched|| DelegateFormSubmitted )}"></textarea>            
</div>
          <div class="col col-md-12" style="margin-bottom: 15px;" *ngIf="isRequiredTrainingDelegated">
            <label class="control control--checkbox mt-2" style="width:100%;margin-bottom:2px !important;">
              <input type="checkbox" formControlName="MakeDelegateTrainingOptional"/>
              <span class="control__indicator"></span>
              <span>Make any required training for {{DelegateTrainingInputData.DelegateUser.Name}} optional training</span>
            </label>
              <span *ngIf="DelegateTrainingInputData.isFromMyTraining" style="padding-left:25px;">This option will only effect required training. Optional training shall remain optional.</span>
          </div>
          <div class="col col-md-12">
            <label class="control control--checkbox">
              <input type="checkbox" formControlName="WaiverTrainingToCurrentUser"/>
              <span class="control__indicator"></span>
              <span>Waive delegated training for {{DelegateTrainingInputData.DelegateUser.Name}}</span>
              <span class="icon-info" style="padding-left: 6px; padding-top: 4px; color: #00679A;" matTooltip="The training will be waived for the displayed user. If the training was previously waived for this user, it will remain waived regardless of the current selection."
                    [matTooltipPosition]="'above'">
              </span>
            </label>
          </div>
          <div class="col col-md-12">
            <label class="control control--checkbox">
              <input type="checkbox" formControlName="SendEmailNotification" />
              <span class="control__indicator"></span>
              <span>Send email notification</span>
            </label>
          </div>
        </form>
      </ng-template>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="row">
    <div class="col-12 columns">
      <input *ngIf="DelegateTrainingInputData.Assets.length == 0" type="button" class="secondaryBtn pull-right" medpt-log-action="Click" medpt-log-message="Close Delegate Training Modal" value="Close" (click)="modal.close(false)" />

      <button type="submit" class="primaryBtn pull-right" *ngIf="DelegateTrainingInputData.Assets.length > 0" form="delegateform" ngbAutofocus medpt-log-action="Save" medpt-log-message="Save Close Delegate Training">Save</button>

      <input id="btnClose" type="button" value="Cancel" medpt-log-action="Click" medpt-log-message="Cancel Delegate Training Modal"
             (click)="modal.close(false)"
             class="secondaryBtn pull-right" style="margin-left: 12px;padding: 6px 12px;" *ngIf="DelegateTrainingInputData.Assets.length > 0" />
    </div>
  </div>
</div>
<!--</div>-->
